import React, { useState } from "react";
import * as yup from "yup";
import useForm from "../../hooks/useForm";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import produce from "immer";
import { Redirect, useHistory } from "react-router-dom";

// REDUX
import { initializeApp } from "_redux/initializeAppSlice";

// COMPONENTS
import LoadingMutation from "../Loading/LoadingMutation";

// AWS
import { Auth } from "aws-amplify";
import classNames from "classnames";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const schema = yup.object({
  username: yup.string().required("โปรดกรอก Username"),
  code: yup.string().required("โปรดกรอก Code"),
  new_password: yup
    .string()
    .required("โปรดกรอกรหัสผ่าน")
    .min(8, "โปรดกรอกรหัสผ่านอย่างน้อย 8 ตัวอักษร"),
});

const initialState = { username: "", code: "", new_password: "" };

function ResetPassword() {
  const { push } = useHistory();
  const { form, setForm, setValue, handleSubmit, errors } = useForm({
    initialState,
    resolver: schema,
  });
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.initializeApp);
  const [loading, setLoading] = useState(false);

  const onClickReset = async () => {
    const { values, errors, isError } = handleSubmit();
    if (isError) {
      return setForm(
        produce(form, (draftState) => {
          draftState.new_password = "";
        })
      );
    }
    setLoading(true);
    try {
      await Auth.forgotPasswordSubmit(
        form.username,
        form.code,
        form.new_password
      );
      push(`/login`);
    } catch (error) {
      console.log("error signing up:", error);
      await Swal.fire({
        title: "ERROR",
        text: error?.message || "Sonething went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    } finally {
      setLoading(false);
    }
  };

  if (user) {
    return <Redirect to="/" />;
  }
  const notify = () => toast("คุณล็อคอินเรียบร้อยแล้ว!");
  return (
    <div className="bg-grey-lighter min-h-screen flex flex-col">
      <div className="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2">
        <div className="bg-white px-6 py-8 rounded shadow-xl border border-gray-100 text-black w-full">
          <img className="mx-auto w-28 h-28 mb-8	" src="/icon.png"></img>

          <div className="mb-4">
            <input
              onChange={setValue}
              value={form.username}
              type="text"
              className="block border border-grey-light w-full p-3 rounded"
              name="username"
              placeholder="Username"
            />
            {errors.username && !form.username && (
              <span className="text-red-500">{errors.username.message}</span>
            )}
          </div>

          <div className="mb-4">
            <input
              onChange={setValue}
              value={form.code}
              type="text"
              className="block border border-grey-light w-full p-3 rounded"
              name="code"
              placeholder="Code"
            />
            {errors.code && !form.code && (
              <span className="text-red-500">{errors.code.message}</span>
            )}
          </div>

          <div className="mb-4">
            <input
              onChange={setValue}
              value={form.new_password}
              type="password"
              className="block border border-grey-light w-full p-3 rounded"
              name="new_password"
              placeholder="New Password"
            />
            {errors.new_password && !form.new_password && (
              <span className="text-red-500">
                {errors.new_password.message}
              </span>
            )}
          </div>

          <button
            disabled={loading}
            onClick={onClickReset}
            type="submit"
            className={classNames(
              " items-center flex bg-green-500 justify-center w-full text-center py-3 rounded text-white hover:bg-green-dark focus:outline-none my-1",
              {
                "bg-gray-400": loading,
              }
            )}
          >
            {loading && (
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="currentColor"
                  strokeWidth={4}
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}{" "}
            ยืนยัน
          </button>
          <div
            onClick={() => push("/login")}
            className="text-blue-600 hover:text-blue-500"
          >
            Login
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
